export default "__VITE_ASSET__tZq6_6jY__"